<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>학생을 위한 글쓰기 도구,
                            <br />교수진을 위한 손쉬운 평가!
                        </h1>
                        <p>트링카의 첨단 AI 시스템으로 학생들의 작문
                            <br>실력 향상을 도울 뿐만 아니라, 학문적 글쓰기에 대한 관행을 실습을
                            <br>통해 학습할 수 있습니다. 교수진은 자동화된 평가와 통찰로 집중적인 피드백이 가능합니다.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/K12-and-elearning.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>개별 맞춤형 솔루션
                        </h2>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="most_suited_point">
                        <ul>
                            <li>학교/K-12(유치원에서 고등학교까지)</li>
                            <li>대학</li>
                            <li>영어 학습 앱</li>
                            <li>E-러닝 플랫폼</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>글로벌
                        <br>사용자
                    </h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/paterson.png" alt="paterson">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/abraham-lincoln.png" alt="lincoln">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AmericanCollegeofGreece.png" alt="">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/act.png" alt="act">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AguaFriaUnion.png" alt="AguaFriaUnion">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/almosa.png" alt="almosa">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/amalAcademy.png" alt="amal">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AmericanschoolofDubai.png" alt="dubai">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/lusaka.png" alt="lusaka">
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>학습자 및 교직원을 위한 고품질 보조 툴</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카는 학생들이 더 나은 창작물을 만들고 학술적 글쓰기의 표준을 익힐 수 있도록 돕습니다. 교수진은 학생들의 작문에 대해 통찰력 있는 보고서도
                            <br>받아보게 됩니다.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Real-timewritingsuggestions.png" alt="suggestions" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>학생을 위한 실시간 글쓰기 제안</h3>
                                    <p>트링카는 학술 작문을 위하여 특별히 제작되었습니다. 트링카는 복잡한 문법 오류를 수정하는 것은 물론 어휘, 어조, 구문 등을 향상해 드립니다. 상세한 제안
                                        역시 학생들이 보면서 배울 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Qualityassessment.png" alt="Quality_Assessment" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>학생을 위한 맞춤형 품질점수</h3>
                                    <p>학생들은 사용자 지정 가능한 채점 알고리즘을 사용하여 글쓰기 품질에 대한 실시간 통찰을 얻을 수 있습니다. 상세한 설명과 실시간 제안은 학생들이 글쓰기를
                                        배우고 향상하는 데 도움이 됩니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Automatedfilecorrections.png" alt="automated" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>자동화된 파일 수정 및 오류 보고서</h3>
                                    <p>MS Word 문서를 업로드하는 간단한 작업만으로 몇 분 안에 모든 오류에 대한 자세한 보고서와 함께 변경 사항 추적이 포함된 교정 파일을 받아볼 수 있습니다.
                                        트링카를 사용하면 평가와 피드백 제공이 더 빠르고 쉬워집니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="analytics" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>종합 분석</h3>
                                    <p>풍부한 분석을 통해 학습자가 트링카를 사용하는 방법을 알아보거나 개별 학습자의 활동을 상세히 분석해 보세요. 효과적인 평가와 피드백에 도움이 됩니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="ppc" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>표절 검사 </h3>
                                    <p>가장 진보된 텍스트 유사도 탐지 알고리즘인 iThenticate와 최대 규모의 유료 출판 데이터베이스를 통해 최고 품질의 표절 검사를 제공합니다.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/FileLevelRestrictions.svg" alt="restriction" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>파일 수준 제어</h3>
                                    <p>트링카의 세분화된 제어 기능을 통해 인하우스 학생과 원격 학습자의 액세스를 쉽고 안전하게 관리할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="easy use" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>쉬운 관리</h3>
                                    <p>트링카를 사용하면 몇 초 만에 액세스를 관리하고 라이선스를 교환하거나 구성원을 추가할 수 있으며 나머지는 자동화할 수 있습니다.</p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="Dedicated_Support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>전담 지원</h3>
                                    <p>전담 성공 매니저가 배정되어 트링카를 최대로 활용할 수 있도록 지원해 드립니다. 이러한 지원은 상세한 온보딩 안내 통화, 도움말 문서 및 설명 영상을 포함합니다.
                                    </p>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>K-12 & E-러닝을 위한 트링카 엔터프라이즈
                    </h2>
                    <div class="HeadingSubLine"></div>
                    <p>맞춤형 기능을 통해 트링카가 교육 플랫폼에서 발휘하는 진정한 위력을 경험해 보세요.
                    </p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>학습 진도 추적</h4>
                                <p>상세한 통찰이 포함된 평가를 사용하여 시간의 흐름에 따른 개별 학생의 글쓰기 향상 내용을 평가하고 추적합니다.
                                </p>
                                <ul>
                                    <li>글 품질점수</li>
                                    <li>오류 카테고리별 품질 보고서</li>
                                    <li>학습자 지원을 위한 수정 및 제안</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>학습 격차 식별</h4>
                                <p>오류 유형과 빈도 및 사용자 지정 가능 점수에 대한 통찰을 통해 개별 학습자에게 필요한 사항을 식별합니다.</p>
                                <ul>
                                    <li>사용자 지정 가능한 자동 품질 평가 알고리즘</li>
                                    <li>카테고리별 오류 요약</li>
                                    <li>평가 및 피드백을 위한 수정 사항 추적</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="all_usecases_item all_usecases_item_last">
                                <h4>실시간 학습 지원</h4>
                                <p>트링카의 AI는 실시간으로 작문을 평가하고 즉시 수정 사항과 제안을 제공하여 학습자가 개선 내용을 식별하고 더 나은 글쓰기 관행을 배울 수 있도록 도와줍니다.</p>
                                <ul>
                                    <li>맥락별 맞춤 학습 기회</li>
                                    <li>수정과 수정 내용에 대한 자세한 설명</li>
                                    <li>대화형 품질점수</li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>학습자가 글을 쓰는 곳이면 어디든 글쓰기 지원</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>트링카는 다양한 플랫폼에서 액세스할 수 있기에, 학습자는 브라우저에서 Microsoft Word에 이르기까지 글을 쓰는 어디에서나 강력한 글쓰기 지원을 받을 수 있습니다.</p>
            </div>
        </div>
        <div class="row">

            <div class="col-md-4">
                <div class="features_cards">

                    <h3>클라우드 에디터</h3>


                    <p>
                        안전한 웹 기반 애플리케이션을 통해 어디에서나 트링카의 잠재력을 최대로 활용해 보세요.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>MS Word 추가 기능</h3>
                    <p>
                        MS Word 내에서 글쓰기 제안이 전달되도록 하여 팀의 생산성을 높여보세요.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>브라우저 플러그인</h3>
                    <p>
                        즐겨 사용하는 모든 브라우저에 적합한 플러그인을 통해 모든 웹사이트에서 실시간 글쓰기 지원을 받아보세요.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>나에게 맞는 맞춤형 가격 책정</h2>
                </div>
                <p>트링카는 고유한 요구 사항에 맞게끔 개별 사용자나 사용량에 기반하여 가격을 유연하게 책정해 드립니다.
                    <br>추가 비용 없이 실시간으로 사용자를 전환하고 사용 제한을 적용해 보세요.
                    <br>구매 주문서(PO)/인보이스를 통해 번거롭지 않은 맞춤형 계약 및 단일 결제 옵션을 생성하도록 협력해 드리겠습니다.</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>안전, 보안, 신뢰</h3>
                        <p>트링카는 데이터 보안과 개인 정보 보호를 최우선으로 생각합니다. 내 모든 데이터는 강력하게 암호화되어 안전하게 저장됩니다. 다른 사람은 내 데이터에 액세스할 수 없습니다. 트링카는
                            글쓰기 제안을 받으면 데이터 저장을 제거하는 고유한 플랜을 제공해 드립니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="AI" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>AI 소개</h3>
                        <p>트링카는 최신 머신러닝(ML) 및 자연어 처리(NLP) 기술을 사용하여 문법 오류를 식별하고 언어 향상을 제안합니다. 의학, 생명과학, 생물학, 물리학, 공학, 인문학, 비즈니스
                            및 예술을 포함한 1300개 이상의 주제 영역을 망라하며 모범적으로 작성된 논문 및 기사 수백만 건을 바탕으로 훈련되기에 해당 주제에 가장 적절한 제안을 제공합니다.</p>
                        <p>트링카는 장벽 없는 커뮤니케이션을 통해 미래를 만들어가고자 하는 깊은 열망을 품은 언어학자, 의학 에디터, 데이터 과학자 및 엔지니어로 이루어진 팀이 개발했습니다.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>트링카로 비즈니스 커뮤니케이션을 혁신해 보세요</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">견적 문의</button>
</div>

<app-enterprise-modal></app-enterprise-modal>